export const addresses = {
  font:"0x980aAc123617e2B2ea407081Ceb72d5854BAa3D1",
}
